import { useEffect } from 'react';
import { FlattenInterpolation, ThemeProps } from 'styled-components';
import {
  useModelForm,
  FormInput,
  ThemeType,
  UpdateType,
  TripleToggleInput,
  TripleToggleButtonProps,
} from '../../../../..';

export type ModelTripleToggleProps = Omit<TripleToggleButtonProps, 'onChange'> & {
  field: string,
  valueOverride?: string,
  errorOverride?: string,
  containerCss?: FlattenInterpolation<ThemeProps<ThemeType>> | string,
  onVisibleChange?: (visible: boolean) => void,
  updateOverride?: UpdateType,
}

export function ModelTripleToggle({
  id,
  field,
  valueOverride,
  errorOverride = '',
  containerCss,
  onVisibleChange,
  updateOverride,
  ...props
}: ModelTripleToggleProps) {
  const {
    visible, errors, value, update,
  } = useModelForm(field, valueOverride, errorOverride, updateOverride);

  useEffect(() => {
    onVisibleChange?.(visible);
  }, [visible]);

  return (
    <FormInput visible={visible} css={containerCss} id={id}>
      <TripleToggleInput
        id={id}
        value={value === '' ? null : value}
        onChange={(newValue: string) => update({ [field]: newValue })}
        errors={errors}
        {...props}
      />
    </FormInput>
  );
}
